import { XMarkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

interface OfflineIndicatorProps {
  show: boolean;
}

export default function OfflineIndicator({ show }: OfflineIndicatorProps) {
  const [dismissed, setDismissed] = useState(false);

  if (!show || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 max-w-xs bg-yellow-50 border border-yellow-200 rounded-lg p-4 shadow-lg">
      <div className="flex items-start">
        <div className="flex-1">
          <p className="text-sm text-yellow-800">
            Modalità offline attiva. I dati potrebbero non essere aggiornati.
          </p>
        </div>
        <button
          className="ml-4 text-yellow-500 hover:text-yellow-600"
          onClick={() => setDismissed(true)}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}